export default "__VITE_ASSET__Q_w93hTU__"